import React, {useState, useCallback, useMemo} from 'react';
import SmallScreenAlert from './SmallScreenAlert.component';
import translate from '../translations/translations.wrapper.jsx';
import {Outlet} from "react-router-dom";
import ModalRouter from 'components/modals/ModalRouter';
import {ModalContext} from 'components/modals/ModalContext';
import VsnNavigation from '../navigation/VsnNavigation.component';

// this.props.children is determined by router definition
const PageLayout = () => {
    const [modalType, setModalType] = useState(null);
    const [modalProps, setModalProps] = useState(null);

    const toggleModal = useCallback((type, more) => {
        setModalType(type);
        setModalProps(more);
    }, []);

    const modalValue = useMemo(() => ({toggleModal}), []);
    return (
        <div>
            <ModalRouter type={modalType} toggleModal={toggleModal} more={modalProps}/>
            <ModalContext.Provider value={modalValue}>
                <VsnNavigation>
                    <div className="app-width full-height-container container-fluid">
                        <Outlet/>
                        <SmallScreenAlert/>
                    </div>
                </VsnNavigation>
            </ModalContext.Provider>
        </div>
    )
}
const withTranslations = translate(PageLayout);
export default withTranslations;
